"use client";

import { IconLoader } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import * as React from "react";
import { StoreSeoSection } from "@/features/store-settings/components/store-seo-section";
import { useStoreDetails } from "@/features/store-settings/hooks/use-store-details";
import { useStoreSlug } from "@/hooks/use-store-slug";
import { useStores } from "@/hooks/use-stores";

export const Route = createFileRoute("/$store/_layout/settings_/seo")({
	component: SeoSettingsPage,
});

function SeoSettingsPage() {
	const storeSlug = useStoreSlug();
	const { stores, isLoading } = useStores();
	const { storeDetails, isLoading: isLoadingDetails } = useStoreDetails();

	const currentStore = React.useMemo(() => {
		if (!storeSlug) return null;
		return stores.find((store) => store.slug === storeSlug) || null;
	}, [storeSlug, stores]);

	if (isLoading || isLoadingDetails) {
		return (
			<div className="flex items-center justify-center h-64">
				<IconLoader className="size-6 animate-spin text-muted-foreground" />
			</div>
		);
	}

	if (!currentStore) {
		return (
			<div className="flex items-center justify-center h-64">
				<p className="text-muted-foreground">Loja não encontrada.</p>
			</div>
		);
	}

	const seoData = (storeDetails?.metadata as Record<string, any>)?.seo ?? {};
	const initialKeywords = Array.isArray(seoData.keywords)
		? seoData.keywords
		: [];
	const initialSeoTitle =
		typeof seoData.customTitle === "string" ? seoData.customTitle : "";
	const initialSeoDescription =
		typeof seoData.customDescription === "string"
			? seoData.customDescription
			: "";

	return (
		<div className="flex flex-col gap-6 px-4 py-6 lg:px-6">
			<div>
				<h1 className="text-2xl font-semibold text-foreground">
					Configurações de SEO
				</h1>
				<p className="text-sm text-muted-foreground">
					Otimize o posicionamento da sua loja nos mecanismos de busca
				</p>
			</div>

			<StoreSeoSection
				storeName={currentStore.name}
				storeDomain={storeSlug ? `${storeSlug}.atomicstore.com` : undefined}
				initialKeywords={initialKeywords}
				initialSeoTitle={initialSeoTitle}
				initialSeoDescription={initialSeoDescription}
			/>
		</div>
	);
}
